import React from "react";

const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_terminal-vessel-hub/artifacts/7ut8b175_BackgroundEraser_20260423_103411885.png";

/**
 * Official Grindrod logo.
 * variant: "light" (shows the image directly, for white/light backgrounds)
 *        | "dark"  (wraps logo in a white chip so it stays legible on navy headers)
 * subtitle: optional (e.g. "RICHARDS BAY DIVISION")
 * size: sm | md | lg | xl
 */
export default function GrindrodLogo({ variant = "light", subtitle, size = "md", subline = "TERMINALS", slogan = "THE GRINDROD WAY", layout = "inline" }) {
    const h =
        size === "3xl" ? 264 : size === "2xl" ? 176 : size === "xl" ? 88 : size === "lg" ? 64 : size === "sm" ? 36 : 48; // image height in px
    const subColor = variant === "dark" ? "#CBD5E1" : "#475569";
    const sloganColor = variant === "dark" ? "#FFFFFF" : "#0B1B3D";

    const img = (
        <img
            src={LOGO_URL}
            alt="Grindrod"
            style={{ height: h, width: "auto", display: "block" }}
            draggable={false}
        />
    );

    const wrapperClass = layout === "stack"
        ? "inline-flex flex-col items-start gap-2"
        : "inline-flex flex-row items-center gap-3";

    return (
        <div className={wrapperClass} data-testid="grindrod-logo">
            {variant === "dark" ? (
                <div
                    style={{
                        background: "#FFFFFF",
                        padding: "6px 10px",
                        borderRadius: 4,
                        display: "inline-flex",
                        alignItems: "center",
                    }}
                >
                    {img}
                </div>
            ) : (
                img
            )}
            {(subline || subtitle || slogan) && (
                <div className="leading-tight text-left">
                    {subline && (
                        <div
                            className="font-display font-bold"
                            style={{
                                color: subColor,
                                fontSize: size === "3xl" ? 20 : size === "2xl" ? 16 : size === "xl" ? 11 : 10,
                                letterSpacing: "0.22em",
                            }}
                        >
                            {subline}
                        </div>
                    )}
                    {subtitle && (
                        <div
                            className="font-display"
                            style={{
                                color: "#E3000F",
                                fontSize: size === "3xl" ? 17 : size === "2xl" ? 14 : size === "xl" ? 10 : 9,
                                letterSpacing: "0.22em",
                                fontWeight: 800,
                                marginTop: size === "3xl" ? 8 : size === "2xl" ? 6 : 3,
                            }}
                        >
                            {subtitle}
                        </div>
                    )}
                    {slogan && (
                        <div
                            data-testid="grindrod-slogan"
                            className="font-display italic"
                            style={{
                                color: sloganColor,
                                fontSize: size === "3xl" ? 16 : size === "2xl" ? 13 : size === "xl" ? 10 : 9,
                                letterSpacing: "0.18em",
                                fontWeight: 700,
                                marginTop: size === "3xl" ? 12 : size === "2xl" ? 10 : 4,
                                opacity: variant === "dark" ? 0.85 : 0.9,
                            }}
                        >
                            {slogan}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
